import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { readLocalStorage } from "./usePersistedState";
import config from "../../config.json";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function isDev(): boolean {
  return (
    import.meta.env.MODE === "development" ||
    import.meta.env.CONTEXT === "deploy-preview" ||
    // For now enable mocking on all deploys on netlify
    // Will be removed when having a real production env
    import.meta.env.CONTEXT === "production" ||
    import.meta.env.CONTEXT === "branch-deploy"
  );
}

export function enableMockServer(): boolean {
  if (!isDev()) return false;

  const mockEnv = localStorage.getItem("dev_environment");
  return !mockEnv || JSON.parse(mockEnv) === "Mock";
}

export function getEnvSettings() {
  if (!isDev()) return config.production;
  const env = readLocalStorage<keyof typeof config.devEnvs>("dev_environment");
  return config.devEnvs[env ?? "Mock"] ?? config.devEnvs.Mock;
}

export const mockAuthUrl = "/sit-auth/oauth/authorize";

// Opcenter logic, stolen from existing code to get correct string
const encode = (str: string) => {
  const array = new Uint8Array(
    new Uint16Array([...str].map((c) => c.charCodeAt(0))).buffer
  );

  return btoa(String.fromCharCode(...array));
};

interface OpcenterMduiCtx {
  stateParams?: { Id: string; isDrillDownState: boolean };
  tracking?: {
    index: number;
    screenId: string;
    master: { id: string };
    detail: any;
    params: any;
  }[];
}

export const createOpcenterMduiCtx = (ctx: OpcenterMduiCtx) => {
  return encode(JSON.stringify(ctx));
};
